import React from 'react';
import * as RT from '../../../constants/Routing.js';
import Form from '../Form';
import { Redirect } from 'react-router-dom';

export default class Component extends React.Component {

  componentWillMount = () => {
    this.props.communityGet(this.props.match.params.id)
  }

  componentWillReceiveProps = () => {
    
  }

  componentDidMount = () => {
  }

  componentWillUnmount = () => {
    this.props.communityUpdateReset()
  }

  shouldComponentUpdate = (nextProps) => {
    if ((this.props.App.infoMsg !== null && this.props.App.infoMsgType !== null) && (nextProps.App.infoMsg === null && nextProps.App.infoMsgType === null)) {
      return false
    } else {
      return true
    }
    // return true
  }

  render = () => {
    const currentUser = this.props.App.currentUser
    const selectedCommunity = this.props.Community.community
    if (selectedCommunity === false || (!!currentUser && !!selectedCommunity && !!selectedCommunity.host && selectedCommunity.host.id !== currentUser.id) ) {
      return (
        <Redirect to={RT.USER_MYPAGE_PATH}/>
      )
    }

    
    return (
      <section className='container'>
        <Form title='サークルを編集' method='update' communityPreviewSet={this.props.communityPreviewSet} currentUser={currentUser} circle={selectedCommunity} communitySave={this.props.communityUpdate} />
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Community/Edit/Edit.jsx